module.exports = __webpack_public_path__ + "static/media/blog_grid_3.f32d1ab0.jpg";